<template>
  <div class="manage-page">
    <div class="bg-deco" aria-hidden="true">
      <div class="bg-deco-icon i1"><img src="../assets/images/stars.png" alt="" /></div>
      <div class="bg-deco-icon i2"><img src="../assets/images/cloud3.png" alt="" /></div>
      <div class="bg-deco-icon i3"><img src="../assets/images/rainbow2.png" alt="" /></div>
      <div class="bg-deco-icon i4"><img src="../assets/images/butterfly2.png" alt="" /></div>
      <div class="bg-deco-icon i5"><img src="../assets/images/award.png" alt="" /></div>
    </div>

    <b-modal
      :active.sync="modalCreateNewTeacher"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal>
      <set-user type="ST" @over="modalCreateNewTeacher = false" />
    </b-modal>
    <b-modal
      :active.sync="modalCreateNewStudent"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal>
      <set-user type="P" @over="modalCreateNewStudent = false" />
    </b-modal>

    <div class="page-header">
      <div>
        <h1 class="page-title">Manage Accounts</h1>
        <p class="page-subtitle" v-if="getUserSchoolName">{{ getUserSchoolName }}</p>
      </div>
      <div class="page-tabs">
        <button
          class="page-tab"
          :class="{ 'is-active': activeTab === 'ST' }"
          @click="activeTab = 'ST'"
        >
          <span class="page-tab-dot" style="--dot-color: rgb(137 25 231)"></span>
          Teachers
        </button>
        <button
          class="page-tab"
          :class="{ 'is-active': activeTab === 'P' }"
          @click="activeTab = 'P'"
        >
          <span class="page-tab-dot" style="--dot-color: rgb(49 200 255)"></span>
          Students
        </button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h2 class="panel-title">{{ activeTab === 'ST' ? 'Teachers' : 'Students' }}</h2>
          <p class="panel-sub">{{ activeTab === 'ST' ? 'Manage teaching staff for your school' : 'Manage students enrolled in your school' }}</p>
        </div>
        <button class="btn-primary" @click="openModal">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          <span>Add {{ activeTab === 'ST' ? 'Teacher' : 'Student' }}</span>
        </button>
      </div>

      <div class="panel-body">
        <UserTable :type="activeTab" :key="activeTab"></UserTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserTable from '@/components/School/UserTable.vue'
import SetUser from '@/components/School/SetUser.vue'

export default {
  name: 'ManageAccount',
  components: { UserTable, SetUser },
  data() {
    return {
      modalCreateNewTeacher: false,
      modalCreateNewStudent: false,
      activeTab: 'ST'
    }
  },
  computed: {
    ...mapGetters(['getUserSchoolName'])
  },
  methods: {
    openModal() {
      if (this.activeTab === 'ST') this.modalCreateNewTeacher = true
      else this.modalCreateNewStudent = true
    }
  }
}
</script>

<style scoped>
.manage-page {
  position: relative;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: clamp(1rem, 2.5vw, 2rem) clamp(0.75rem, 2vw, 1.5rem);
  min-height: 100vh;
  background:
    radial-gradient(1100px 480px at 50% -120px, rgba(137, 25, 231, 0.08), transparent 60%),
    radial-gradient(900px 420px at 100% 100%, rgba(49, 200, 255, 0.10), transparent 60%);
}

.manage-page::after {
  content: '';
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 38vh;
  max-height: 380px;
  background-image: url(../assets/images/cloud2.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center;
  pointer-events: none;
  z-index: 0;
  opacity: 0.85;
}

.bg-deco {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}
.bg-deco-icon {
  position: absolute;
  width: clamp(36px, 5vw, 64px);
  opacity: 0.6;
  animation: bg-float 6s ease-in-out infinite;
}
.bg-deco-icon img {
  width: 100%;
  height: auto;
  display: block;
}
.bg-deco-icon.i1 { top: 6%;  left: 4%;  animation-delay: 0s; }
.bg-deco-icon.i2 { top: 10%; right: 6%; animation-delay: -1.5s; }
.bg-deco-icon.i3 { top: 38%; right: 2%; animation-delay: -2.2s; width: clamp(50px, 7vw, 90px); }
.bg-deco-icon.i4 { top: 60%; left: 2%;  animation-delay: -3s; }
.bg-deco-icon.i5 { top: 80%; right: 7%; animation-delay: -4s; }

@keyframes bg-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50%      { transform: translateY(-12px) rotate(3deg); }
}

.page-header,
.panel {
  position: relative;
  z-index: 2;
}

@media screen and (max-width: 640px) {
  .bg-deco-icon.i2,
  .bg-deco-icon.i4 { display: none; }
}

.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.page-title {
  font-size: clamp(1.5rem, 2.6vw, 2.2rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 0 0 0.15rem;
  background: linear-gradient(135deg, #8919e7 0%, #4361ee 60%, #31c8ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  line-height: 1.1;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
}

.page-tabs {
  display: inline-flex;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  padding: 4px;
  gap: 2px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.page-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 600;
  color: #64748b;
  padding: 0.55rem 1rem;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.page-tab:hover {
  color: #1f2937;
}

.page-tab.is-active {
  background: #1f2937;
  color: #ffffff;
}

.page-tab-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--dot-color, #8919e7);
  display: inline-block;
}

.panel {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fafbfd, #ffffff);
}

.panel-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.panel-sub {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0.15rem 0 0;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  color: #ffffff;
  border: none;
  padding: 0.55rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(137, 25, 231, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(137, 25, 231, 0.34);
}

.btn-primary:active {
  transform: translateY(0);
  opacity: 0.95;
}

.panel-body {
  padding: 1rem 1.25rem 1.25rem;
}

@media screen and (max-width: 640px) {
  .page-header {
    align-items: flex-start;
  }
  .page-tabs {
    width: 100%;
  }
  .page-tab {
    flex: 1;
    justify-content: center;
  }
  .panel-header {
    flex-direction: column;
    align-items: stretch;
  }
  .btn-primary {
    width: 100%;
    justify-content: center;
  }
}
</style>
